<template>
  <div>
    <b-navbar-nav class="bg-light h-100 headerFull">
      <div v-for="(group, index) in items" :key="index">
        <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
        <b-nav-item
          v-for="(item, idx) in group"
          v-bind:key="idx"
          v-if="item.title !== 'Theme'"
          @click="$router.push(`${item.router}`)"
          :class="{
            'mt-3': index === 0,
          }"
          :disabled="item.enable === false"
        >
          <span 
            class="material-icons-outlined align-middle ml-4 mr-2 "
            :class="item.enable === false ? 'text-secondary' : 'color-secundary'"
          >{{
            item.img
          }}</span>
          <span 
            :class="item.enable === false ? 'text-secondary' : 'color-secundary'"
          >
          {{ item.title }}
        </span>
        </b-nav-item>
        <div v-else>
          <b-nav-item-dropdown id="theme" right class="ml-4">
            <template v-slot:button-content>
              <span class="material-icons align-middle mr-2"></span>
              <span class="text-muted">{{ item.title }}</span>
            </template>
            <b-dropdown-item
              v-for="(palette, paletteIdx) in item.palette"
              :key="paletteIdx"
              class="d-inline-block"
              @click="changePalette(paletteIdx)"
            >
              <span class="material-icons big-icon" :class="`${palette.color}`">
                lens
              </span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
        <hr v-if="index < items.length - 1" class="mx-3 my-2" />
      </div>
    </b-navbar-nav>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { getMenuItems } from '@/common/utils';

export default {
  data() {
    return { darkMode: false };
  },
  mounted() {
    this.darkMode = this.getDarkMode;
  },
  watch: {
    darkMode(newMode, oldMode) {
      this.darkModeChange(newMode);
    },
  },
  props: {
    userIsAParent: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('user', ['token', 'userIsLogged', 'getDarkMode']),
    ...mapGetters('coins', ['getChildCoinsBanked', 'getChildLevelPoints']),
    ...mapGetters('notifications', ['getNotificationList']),
    notifications() {
      return this.getNotificationList.slice(0, 2);
    },
    countNotfications() {
      let count = 0;
      this.getNotificationList.forEach((element) => {
        if (!element.read) {
          count++;
        }
      });
      return count;
    },
    items() {
      return getMenuItems(this.userIsAParent);
    },
  },
  methods: {
    ...mapActions({
      logoutAction: 'user/logout',
    }),
    ...mapActions('user', ['darkModeChange']),

    logout() {
      this.logoutAction().then(() => {
        this.$router.push('/login');
      });
    },
    changePalette(colorIndex){
      this.$emit("changeTheme", colorIndex);
    }
  },
};
</script>
<style lang="scss">
li#theme > ul {
  & > div {
    font-weight: 500;
    display: flex !important;
    flex-wrap: wrap !important;
    border-radius: 0.8rem;
    & > div {
      display: flex;
      flex-wrap: wrap !important;
      & > li {
        & > a {
          border-radius: 0.8rem;
          padding: 1rem !important;
        }
      }
    }
  }
}

.navbar-nav .nav-link {
  text-align: left !important;
}
a:hover {
  background: rgba(0, 0, 0, 0.05);
}

.logoutStyle {
  margin-top: 100%;
}

.headerFull {
  overflow-y: scroll;
}
</style>
